<div>
    <app-tool-bar [title]="'Manage Features'" (handleAdd)="openAddModal()" [iconName]="'pi-bolt'"
        [selectedProducts]="selectedProducts" [isBulkAction]="false" [isFilter]="false" [isAdd]="true"></app-tool-bar>
</div>

<div class="p-6 overflow-auto h-[85vh] bg-gray-50">
    
    <!-- Loading State -->
    <div *ngIf="loading" class="flex items-center justify-center h-96">
        <p-progressSpinner></p-progressSpinner>
    </div>

    <!-- Main Content -->
    <div *ngIf="!loading">
        
        <!-- Stats Cards -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div class="bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl p-5 text-white shadow-lg">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-teal-100 text-xs font-medium mb-1 uppercase tracking-wide">Fixed Features</p>
                        <h3 class="text-4xl font-extrabold">{{ getFixedFeatures().length }}</h3>
                    </div>
                    <div class="bg-white/20 p-3 rounded-lg">
                        <i class="pi pi-check-circle text-2xl"></i>
                    </div>
                </div>
            </div>

            <div class="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-5 text-white shadow-lg">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-purple-100 text-xs font-medium mb-1 uppercase tracking-wide">Credit Usage Features</p>
                        <h3 class="text-4xl font-extrabold">{{ getLimitFeatures().length }}</h3>
                    </div>
                    <div class="bg-white/20 p-3 rounded-lg">
                        <i class="pi pi-chart-bar text-2xl"></i>
                    </div>
                </div>
            </div>

            <div class="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-5 text-white shadow-lg">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-blue-100 text-xs font-medium mb-1 uppercase tracking-wide">Modules</p>
                        <h3 class="text-4xl font-extrabold">{{ getModules().length }}</h3>
                    </div>
                    <div class="bg-white/20 p-3 rounded-lg">
                        <i class="pi pi-th-large text-2xl"></i>
                    </div>
                </div>
            </div>

            <div class="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-5 text-white shadow-lg">
                <div class="flex items-center justify-between">
                    <div>
                        <p class="text-green-100 text-xs font-medium mb-1 uppercase tracking-wide">Active Features</p>
                        <h3 class="text-4xl font-extrabold">{{ getActiveFeatures().length }}</h3>
                    </div>
                    <div class="bg-white/20 p-3 rounded-lg">
                        <i class="pi pi-bolt text-2xl"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabbed View for Fixed vs Limit -->
        <div class="bg-white rounded-xl shadow-sm border border-gray-200">
            <p-tabView styleClass="feature-tabs">
                
                <!-- FIXED FEATURES TAB -->
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <div class="flex items-center gap-2 px-2">
                            <i class="pi pi-check-circle text-teal-500"></i>
                            <span class="font-bold text-gray-700">Fixed Features</span>
                            <span class="bg-teal-100 text-teal-700 text-xs font-bold px-2 py-0.5 rounded-full">{{ getFixedFeatures().length }}</span>
                        </div>
                    </ng-template>

                    <div class="p-6">
                        <!-- Empty State -->
                        <div *ngIf="getFixedFeatures().length === 0" class="text-center py-12">
                            <i class="pi pi-inbox text-gray-300 text-5xl mb-4"></i>
                            <p class="text-gray-500 text-lg font-medium">No fixed features found</p>
                            <button pButton label="Add Fixed Feature" icon="pi pi-plus" (click)="openAddModal()" class="mt-4"></button>
                        </div>

                        <!-- Hierarchical Tree View -->
                        <div *ngIf="getFixedFeatures().length > 0" class="space-y-4">
                            <div *ngFor="let module of getFixedModules()" class="border border-gray-200 rounded-lg overflow-hidden">
                                
                                <!-- Module Header -->
                                <div class="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 p-4">
                                    <div class="flex items-center justify-between">
                                        <div class="flex items-center gap-3 flex-1">
                                            <div class="bg-blue-500 text-white p-2 rounded-lg">
                                                <i class="pi pi-th-large text-lg"></i>
                                            </div>
                                            <div class="flex-1">
                                                <div class="flex items-center gap-2 mb-1">
                                                    <h3 class="text-xl font-extrabold text-gray-900">{{ module.label }}</h3>
                                                    <span class="text-[10px] font-mono bg-gray-100 text-gray-500 px-2 py-0.5 rounded">{{ module.feature_key }}</span>
                                                    <p-chip 
                                                        [label]="module.status"
                                                        [styleClass]="module.status === 'Active' ? 'bg-green-100 text-green-700 text-[10px] font-semibold' : 'bg-red-100 text-red-700 text-[10px] font-semibold'">
                                                    </p-chip>
                                                </div>
                                                <p *ngIf="module.description" class="text-xs text-gray-500 mt-1">{{ module.description }}</p>
                                            </div>
                                        </div>
                                        <div class="flex items-center gap-2">
                                            <button pButton icon="pi pi-pencil" class="p-button-text p-button-sm" 
                                                (click)="editFeature(module)" pTooltip="Edit Module"></button>
                                            <button pButton icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm" 
                                                (click)="deleteFeature(module)" pTooltip="Delete Module"></button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Module Features -->
                                <div *ngIf="getChildFeatures(module.feature_key, 'fixed').length > 0" class="bg-white">
                                    <div *ngFor="let feature of getChildFeatures(module.feature_key, 'fixed'); let isLast = last" 
                                        class="border-l-4 border-indigo-300 ml-8 pl-4 py-3"
                                        [ngClass]="{'border-b border-gray-100': !isLast}">
                                        
                                        <div class="flex items-center justify-between">
                                            <div class="flex items-center gap-3 flex-1">
                                                <div class="bg-indigo-100 text-indigo-600 p-2 rounded">
                                                    <i class="pi pi-box"></i>
                                                </div>
                                                <div class="flex-1">
                                                    <div class="flex items-center gap-2 mb-1">
                                                        <h4 class="text-base font-bold text-gray-800">{{ feature.label }}</h4>
                                                        <span class="text-[10px] font-mono bg-gray-50 text-gray-400 px-1.5 py-0.5 rounded">{{ feature.feature_key }}</span>
                                                        <p-chip 
                                                            [label]="formatFeatureLevel(feature.feature_level)"
                                                            styleClass="bg-indigo-50 text-indigo-600 text-[10px] font-semibold">
                                                        </p-chip>
                                                        <p-chip 
                                                            [label]="feature.status"
                                                            [styleClass]="feature.status === 'Active' ? 'bg-green-100 text-green-700 text-[10px] font-semibold' : 'bg-red-100 text-red-700 text-[10px] font-semibold'">
                                                        </p-chip>
                                                    </div>
                                                    <p *ngIf="feature.description" class="text-xs text-gray-400 mt-0.5">{{ feature.description }}</p>
                                                </div>
                                            </div>
                                            <div class="flex items-center gap-2">
                                                <button pButton icon="pi pi-pencil" class="p-button-text p-button-sm" 
                                                    (click)="editFeature(feature)" pTooltip="Edit Feature"></button>
                                                <button pButton icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm" 
                                                    (click)="deleteFeature(feature)" pTooltip="Delete Feature"></button>
                                            </div>
                                        </div>

                                        <!-- Sub-Module Features -->
                                        <div *ngIf="getChildFeatures(feature.feature_key, 'fixed').length > 0" class="mt-3 ml-8 space-y-2">
                                            <div *ngFor="let subFeature of getChildFeatures(feature.feature_key, 'fixed')" 
                                                class="border-l-4 border-violet-200 pl-4 py-2 bg-violet-50/30 rounded-r">
                                                
                                                <div class="flex items-center justify-between">
                                                    <div class="flex items-center gap-2 flex-1">
                                                        <div class="bg-violet-100 text-violet-600 p-1.5 rounded">
                                                            <i class="pi pi-angle-right text-sm"></i>
                                                        </div>
                                                        <div class="flex-1">
                                                            <div class="flex items-center gap-2">
                                                                <span class="font-semibold text-gray-700 text-sm">{{ subFeature.label }}</span>
                                                                <span class="text-[9px] font-mono bg-white text-gray-400 px-1.5 py-0.5 rounded">{{ subFeature.feature_key }}</span>
                                                                <p-chip 
                                                                    [label]="formatFeatureLevel(subFeature.feature_level)"
                                                                    styleClass="bg-violet-100 text-violet-600 text-[9px] font-semibold">
                                                                </p-chip>
                                                                <p-chip 
                                                                    [label]="subFeature.status"
                                                                    [styleClass]="subFeature.status === 'Active' ? 'bg-green-100 text-green-700 text-[9px] font-semibold' : 'bg-red-100 text-red-700 text-[9px] font-semibold'">
                                                                </p-chip>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-center gap-1">
                                                        <button pButton icon="pi pi-pencil" class="p-button-text p-button-sm" 
                                                            (click)="editFeature(subFeature)" pTooltip="Edit"></button>
                                                        <button pButton icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm" 
                                                            (click)="deleteFeature(subFeature)" pTooltip="Delete"></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Orphaned Features (Features without parents that aren't modules) -->
                            <div *ngIf="getOrphanedFixedFeatures().length > 0" class="border border-amber-200 rounded-lg overflow-hidden bg-amber-50/30">
                                <div class="bg-amber-50 border-l-4 border-amber-500 p-3">
                                    <div class="flex items-center gap-2">
                                        <i class="pi pi-exclamation-triangle text-amber-600"></i>
                                        <h4 class="text-sm font-bold text-amber-800">Orphaned Features (No Parent Assigned)</h4>
                                        <span class="text-[10px] bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full font-semibold">{{ getOrphanedFixedFeatures().length }}</span>
                                    </div>
                                    <p class="text-xs text-amber-600 mt-1">These features don't have a parent module. Assign them to a module or convert them to modules.</p>
                                </div>
                                
                                <div class="bg-white p-4 space-y-2">
                                    <div *ngFor="let orphan of getOrphanedFixedFeatures()" 
                                        class="border-l-4 border-amber-300 pl-4 py-2 bg-amber-50/20 rounded-r hover:bg-amber-50/40 transition-colors">
                                        
                                        <div class="flex items-center justify-between">
                                            <div class="flex items-center gap-3 flex-1">
                                                <div class="bg-amber-100 text-amber-600 p-2 rounded">
                                                    <i class="pi pi-question-circle"></i>
                                                </div>
                                                <div class="flex-1">
                                                    <div class="flex items-center gap-2 mb-1">
                                                        <h4 class="text-base font-bold text-gray-800">{{ orphan.label }}</h4>
                                                        <span class="text-[10px] font-mono bg-white text-gray-400 px-1.5 py-0.5 rounded">{{ orphan.feature_key }}</span>
                                                        <p-chip 
                                                            [label]="formatFeatureLevel(orphan.feature_level)"
                                                            styleClass="bg-amber-100 text-amber-700 text-[10px] font-semibold">
                                                        </p-chip>
                                                        <p-chip 
                                                            [label]="orphan.status"
                                                            [styleClass]="orphan.status === 'Active' ? 'bg-green-100 text-green-700 text-[10px] font-semibold' : 'bg-red-100 text-red-700 text-[10px] font-semibold'">
                                                        </p-chip>
                                                    </div>
                                                    <p *ngIf="orphan.description" class="text-xs text-gray-400 mt-0.5">{{ orphan.description }}</p>
                                                </div>
                                            </div>
                                            <div class="flex items-center gap-2">
                                                <button pButton icon="pi pi-pencil" class="p-button-text p-button-sm p-button-warning" 
                                                    (click)="editFeature(orphan)" pTooltip="Edit & Assign Parent"></button>
                                                <button pButton icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm" 
                                                    (click)="deleteFeature(orphan)" pTooltip="Delete"></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>

                <!-- LIMIT FEATURES TAB -->
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <div class="flex items-center gap-2 px-2">
                            <i class="pi pi-chart-bar text-purple-500"></i>
                            <span class="font-bold text-gray-700">Credit Usage Features</span>
                            <span class="bg-purple-100 text-purple-700 text-xs font-bold px-2 py-0.5 rounded-full">{{ getLimitFeatures().length }}</span>
                        </div>
                    </ng-template>

                    <div class="p-6">
                        <!-- Empty State -->
                        <div *ngIf="getLimitFeatures().length === 0" class="text-center py-12">
                            <i class="pi pi-inbox text-gray-300 text-5xl mb-4"></i>
                            <p class="text-gray-500 text-lg font-medium">No credit usage features found</p>
                            <button pButton label="Add Credit Usage Feature" icon="pi pi-plus" (click)="openAddModal()" class="mt-4"></button>
                        </div>

                        <!-- Limit Features Grid -->
                        <div *ngIf="getLimitFeatures().length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <div *ngFor="let limit of getLimitFeatures()" 
                                class="bg-white border border-purple-200 rounded-lg p-4 hover:shadow-lg transition-shadow">
                                
                                <div class="flex items-start justify-between mb-3">
                                    <div class="bg-purple-100 text-purple-600 p-2 rounded-lg">
                                        <i class="pi pi-sliders-h text-xl"></i>
                                    </div>
                                    <div class="flex gap-1">
                                        <button pButton icon="pi pi-pencil" class="p-button-text p-button-sm" 
                                            (click)="editFeature(limit)" pTooltip="Edit"></button>
                                        <button pButton icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm" 
                                            (click)="deleteFeature(limit)" pTooltip="Delete"></button>
                                    </div>
                                </div>

                                <h4 class="text-lg font-bold text-gray-900 mb-1">{{ limit.label }}</h4>
                                <p class="text-[10px] font-mono bg-gray-50 text-gray-500 px-2 py-0.5 rounded inline-block mb-2">{{ limit.feature_key }}</p>
                                
                                <div *ngIf="limit.description" class="text-xs text-gray-500 mb-3 line-clamp-2">{{ limit.description }}</div>

                                <div class="flex items-center gap-2 flex-wrap">
                                    <p-chip 
                                        [label]="formatUnitType(limit.unit_type)"
                                        styleClass="bg-blue-100 text-blue-700 text-[10px] font-semibold">
                                    </p-chip>
                                    <p-chip 
                                        [label]="limit.status"
                                        [styleClass]="limit.status === 'Active' ? 'bg-green-100 text-green-700 text-[10px] font-semibold' : 'bg-red-100 text-red-700 text-[10px] font-semibold'">
                                    </p-chip>
                                </div>

                                <div class="mt-3 pt-3 border-t border-gray-100 text-[10px] text-gray-400">
                                    <i class="pi pi-clock mr-1"></i>
                                    {{ limit.createdAt | date: 'short' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>

            </p-tabView>
        </div>
    </div>
</div>

<ng-container *ngIf="displayAddModal">
    <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '60rem'}" [closable]="false">
        <app-add-feature [featureData]="featureDataToEdit" (reload)="reloadFeatures()" (close)="displayAddModal = false"></app-add-feature>
    </p-dialog>
</ng-container>

<ng-container *ngIf="showDeleteFeature">
    <p-dialog [(visible)]="showDeleteFeature" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
        <app-delete-feature 
        [featureDataToEdit]="featureDataToEdit"
        (reload)="reloadFeatures()" (close)="showDeleteFeature = false"></app-delete-feature>
    </p-dialog>
</ng-container>
